import { render, staticRenderFns } from "./newLayout2.vue?vue&type=template&id=18db909a&scoped=true&"
import script from "./newLayout2.vue?vue&type=script&lang=js&"
export * from "./newLayout2.vue?vue&type=script&lang=js&"
import style0 from "./newLayout2.vue?vue&type=style&index=0&id=18db909a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db909a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VContainer,VIcon,VTooltip})
